/* eslint-disable react/jsx-pascal-case */

import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./router";

//test1111
const App = () => {
  return (
    <>
      <ToastContainer />

      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
     
        <Router />
      
      </BrowserRouter>
    </>
  );
};
export default App;
